import {
  combineReducers,
} from 'redux';

import profileStats from './profileStats';
import fileUpload from './fileUpload';
import profileStatsModal from './profileStatsModal';
import earnCoinModal from './earnCoinModal';
import earnCoinForm from './earnCoinForm';

const reducers = combineReducers({
  stats: profileStats,
  fileUpload,
  profileModal: profileStatsModal,
  earnCoinModal,
  earnCoinFormStore: earnCoinForm,
});


export default reducers;
